// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","682":"component---src-pages-about-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"1d0bf84037111b955c27","678":"a3d96f31db087a10a20a","682":"af6e2803800f20afcc3f","883":"78a460ffbc0f8e8b40a4"}[chunkId] + ".js";
};